import { ArrowDownToLine, ArrowUpFromLine, Move } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

export function ScanActionDialog({
  open,
  onOpenChange,
  product,
  locations,
  onScanIn,
  onScanOut,
  onMove,
  processing,
}) {
  if (!product) return null;

  const totalStock = locations.reduce((sum, loc) => sum + (loc.antal || 0), 0);
  const locationsWithStock = locations.filter(loc => (loc.antal || 0) > 0);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="scan-action-dialog">
        <DialogHeader>
          <DialogTitle>Vad vill du göra?</DialogTitle>
          <DialogDescription asChild>
            <div className="pt-2 space-y-2 text-sm text-muted-foreground">
              <p className="font-medium text-foreground">
                {product.produktnamn || product.artikelnummer || product.ean}
              </p>
              {product.artikelnummer && (
                <span className="block text-sm">Art.nr: {product.artikelnummer}</span>
              )}
              <div className="flex items-center gap-2 mt-2">
                <Badge variant="outline">{totalStock} st i lager</Badge>
                <Badge variant="secondary">{locationsWithStock.length} lagerplatser</Badge>
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid grid-cols-3 gap-3 py-4">
          <Button
            variant="outline"
            className="h-24 flex-col gap-2 border-2 hover:border-green-500 hover:bg-green-500/10"
            onClick={onScanIn}
            disabled={processing}
            data-testid="scan-in-btn"
          >
            <ArrowDownToLine className="h-8 w-8 text-green-500" />
            <span className="font-medium">Inleverans</span>
            <span className="text-xs text-muted-foreground">Lägg till lager</span>
          </Button>
          
          <Button
            variant="outline"
            className="h-24 flex-col gap-2 border-2 hover:border-red-500 hover:bg-red-500/10"
            onClick={onScanOut}
            disabled={processing || totalStock === 0}
            data-testid="scan-out-btn"
          >
            <ArrowUpFromLine className="h-8 w-8 text-red-500" />
            <span className="font-medium">Utleverans</span>
            <span className="text-xs text-muted-foreground">Ta från lager</span>
          </Button>
          
          <Button
            variant="outline"
            className="h-24 flex-col gap-2 border-2 hover:border-blue-500 hover:bg-blue-500/10"
            onClick={onMove}
            disabled={processing || totalStock === 0}
            data-testid="move-btn"
          >
            <Move className="h-8 w-8 text-blue-500" />
            <span className="font-medium">Flytta</span>
            <span className="text-xs text-muted-foreground">Byt lagerplats</span>
          </Button>
        </div>
        
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Avbryt
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
